export enum IOsHandler {
  appBootedSuccessfully = 'appBootedSuccessfully',
  completedAssessment = 'completedAssessment',
  exitAssessment = 'exitAssessment',
  exitScoreDetail = 'exitScoreDetail',
  redirectUrlToNativeBrowser = 'redirectUrlToNativeBrowser',
}

type CallHandler = (
  handler: string,
  payload: null | Record<string, any>,
  callback: null | Function
) => void;

export type iOSBridgeType = {
  callHandler: CallHandler;
};
